import { render } from "./ServerDisconnectConfirm.vue?vue&type=template&id=fe1552e0&scoped=true"
import script from "./ServerDisconnectConfirm.vue?vue&type=script&lang=js"
export * from "./ServerDisconnectConfirm.vue?vue&type=script&lang=js"

import "./ServerDisconnectConfirm.vue?vue&type=style&index=0&id=fe1552e0&lang=scss&scoped=true"

import exportComponent from "/var/www/miniapp-sigur-admin-panel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe1552e0"],['__file',"src/assets/js/pages/Popup/ServerDisconnectConfirm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fe1552e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fe1552e0', __exports__)) {
    api.reload('fe1552e0', __exports__)
  }
  
  module.hot.accept("./ServerDisconnectConfirm.vue?vue&type=template&id=fe1552e0&scoped=true", () => {
    api.rerender('fe1552e0', render)
  })

}


export default __exports__